import { render, staticRenderFns } from "./DermatoHistoryTemplate.vue?vue&type=template&id=03aad4c2"
import script from "./DermatoHistoryTemplate.vue?vue&type=script&lang=js"
export * from "./DermatoHistoryTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports